export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/72087054c23720232472e57d0377f195.jpg"
          alt="Massagistas em Curitiba – Spa Premium"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-stone-900/70 via-stone-900/50 to-stone-900/70"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-8 max-w-4xl mx-auto">
        <div className="inline-block mb-6">
          <img
            src="https://static.readdy.ai/image/f3ca0b85088a2ff6b3b1c7af1abe445d/33d5a3400b39a85f6a3e281b88da1a84.png"
            alt="Massagistas Online"
            className="h-16 w-auto mx-auto object-contain mb-6"
          />
        </div>

        <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Massagistas em Curitiba
        </h1>
        <p className="text-xl md:text-2xl text-rose-200 font-light mb-3" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          Atendimento Discreto e Profissional
        </p>
        <p className="text-base md:text-lg text-stone-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          Encontre massagistas relaxantes, terapêuticas e tântricas em Curitiba e região. Profissionais verificadas, atendimento com sigilo e qualidade.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://classivip.com/massagistas"
            target="_blank"
            rel="nofollow noopener"
            className="bg-rose-400 hover:bg-rose-500 text-white font-semibold px-8 py-4 rounded-full text-base transition-all duration-300 hover:scale-105 whitespace-nowrap shadow-lg"
          >
            <i className="ri-eye-line mr-2"></i>
            Ver massagistas disponíveis
          </a>
          <a
            href="#bairros"
            className="bg-white/10 backdrop-blur-sm hover:bg-white/20 border border-white/40 text-white font-medium px-8 py-4 rounded-full text-base transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-map-pin-line mr-2"></i>
            Atendimento por bairro
          </a>
        </div>

        <div className="mt-16 grid grid-cols-3 gap-6 max-w-xl mx-auto">
          <div className="text-center">
            <p className="text-3xl font-bold text-white">100+</p>
            <p className="text-stone-300 text-sm mt-1">Profissionais</p>
          </div>
          <div className="text-center border-x border-white/20">
            <p className="text-3xl font-bold text-white">24h</p>
            <p className="text-stone-300 text-sm mt-1">Disponibilidade</p>
          </div>
          <div className="text-center">
            <p className="text-3xl font-bold text-white">100%</p>
            <p className="text-stone-300 text-sm mt-1">Discreto</p>
          </div>
        </div>
      </div>

      <a
        href="#beneficios"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/60 hover:text-white transition-colors animate-bounce"
        aria-label="Rolar para baixo"
      >
        <i className="ri-arrow-down-line text-2xl"></i>
      </a>
    </section>
  );
}
